import type { UUID } from './common';

export type UserRole = 'admin' | 'feedbacker' | 'coach' | 'client_normal' | 'client_ictc';

export const USER_ROLE_LABELS: Record<UserRole, string> = {
  admin: '管理者',
  feedbacker: 'フィードバッカー',
  coach: 'コーチ',
  client_normal: 'クライアント：ノーマル',
  client_ictc: 'クライアント：ICTC受講者',
};

export function isClientUserRole(role: UserRole | undefined): boolean {
  return role === 'client_normal' || role === 'client_ictc';
}

/**
 * 現在ログイン中のユーザー情報。
 * Cognito の custom claims から復元される。
 *
 * role が5種類の正本。is_feedbacker / is_admin は段階的リリース中の互換フラグ。
 */
export interface CurrentUser {
  id: UUID;
  cognito_sub: string;
  email: string;
  name: string;
  is_feedbacker: boolean;
  is_admin: boolean;
  role: UserRole;
}

export interface UserRef {
  id: UUID;
  name: string;
}
